import { type ProductInterface } from "@jti/fe-common";

export default function getSingleProductPrice(data: ProductInterface): number | null {
  return data?.price_range?.minimum_price?.final_price?.value || null;
}
